import React from 'react';
import { Star, Quote } from 'lucide-react';

const ClientStories = () => {
  const testimonials = [
    {
      name: 'Rajesh Kumar',
      role: 'Business Owner',
      company: 'Kumar Enterprises',
      content: 'CA Pankaj Goyal has been handling our company\'s taxation and audit for the past 4 years. His expertise in GST and corporate compliance has saved us significant time and money. Highly recommended!',
      rating: 5,
    },
    {
      name: 'Priya Sharma',
      role: 'IT Professional',
      company: 'NRI Client',
      content: 'As an NRI, managing taxes in India was always stressful. Mr. Goyal made the entire process seamless - from property tax to fund repatriation. His knowledge of FEMA regulations is exceptional.',
      rating: 5,
    },
    {
      name: 'Amit Jain',
      role: 'Startup Founder',
      company: 'Tech Startup',
      content: 'From company registration to ongoing compliance, Pankaj R Goyal & Associates has been our trusted partner. Their proactive approach to deadlines and clear communication sets them apart.',
      rating: 5,
    },
    {
      name: 'Sunita Agarwal',
      role: 'Retail Business Owner',
      company: 'Agarwal Traders',
      content: 'The team helped us streamline our accounting processes and set up proper bookkeeping systems. Their GST expertise helped us claim maximum input tax credit. Excellent service!',
      rating: 5,
    },
  ];

  return (
    <section id="client-stories" className="py-20 bg-gradient-to-br from-slate-900 to-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-teal-400 font-semibold text-sm uppercase tracking-wide">Testimonials</span>
          <h2 className="text-4xl font-bold text-white mt-3 mb-4">
            Client Stories
          </h2>
          <p className="text-lg text-slate-300 max-w-2xl mx-auto">
            Don't just take our word for it. Here's what our clients have to say about working with us.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10 hover:border-teal-500/50 transition-all duration-300"
            >
              {/* Quote Icon */}
              <div className="mb-4">
                <Quote className="w-10 h-10 text-teal-500 opacity-50" />
              </div>

              {/* Content */}
              <p className="text-slate-300 leading-relaxed mb-6 italic">
                "{testimonial.content}"
              </p>

              {/* Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
                ))}
              </div>

              {/* Author */}
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-teal-600 rounded-full flex items-center justify-center text-white font-bold text-lg">
                  {testimonial.name.charAt(0)}
                </div>
                <div>
                  <h4 className="text-white font-semibold">{testimonial.name}</h4>
                  <p className="text-slate-400 text-sm">{testimonial.role}, {testimonial.company}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Trust Indicators */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
          <div>
            <div className="text-4xl font-bold text-teal-400 mb-2">500+</div>
            <div className="text-slate-400">Happy Clients</div>
          </div>
          <div>
            <div className="text-4xl font-bold text-teal-400 mb-2">7000+</div>
            <div className="text-slate-400">ITRs Filed</div>
          </div>
          <div>
            <div className="text-4xl font-bold text-teal-400 mb-2">6+</div>
            <div className="text-slate-400">Years Experience</div>
          </div>
          <div>
            <div className="text-4xl font-bold text-teal-400 mb-2">98%</div>
            <div className="text-slate-400">Client Satisfaction</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientStories;
